mutation SyncTranslationWords($id: ID!) {
  syncTranslationWords(id: $id) {
    id
    variants {
      languageCode
      translated
      untranslated
      total
    }
  }
}
